<template>
  <div class="page-listing-list">
    <div v-if="companies" class="listing-results">
      <!-- RESULTS -->
      <div class="listing-grid">
        <CompanyListEntry
          v-for="company of companies.results"
          :key="company.id"
          :company="company"
          @delete="confirmDeleteRecord(company.id)"
        />
      </div>
      <!-- PAGINATION -->
      <vs-pagination
        v-model="currentPage"
        class="mt-6 md:mt-0"
        :total="totalPages"
        :max="7"
        icon-pack="fas"
        prev-icon="fa-chevron-left"
        next-icon="fa-chevron-right"
      />
    </div>

    <!-- FILTER -->
    <div class="page-listing-filter">
      <div class="page-listing-filter-fixed">
        <div v-if="companies" style="padding: 0 18px; color: grey">
          Ergebnisse: {{ companies.total }}
        </div>
        <div
          class="filter-title"
          style="padding: 5px 18px 0"
          :class="{ active: mobileFilterOpen }"
          @click="mobileFilterOpen = !mobileFilterOpen"
        >
          Filter-Center
          <div
            v-if="$apollo.queries.companies.loading"
            class="loading-animation"
          >
            <i class="fad fa-spinner-third"></i>
          </div>
          <i class="far fa-chevron-down"></i>
        </div>
        <div class="mb-4" style="padding: 0 18px">
          <span
            class="sm:mb-2 md:mb-3 cursor-pointer clearFilter"
            @click="searchQuery = null"
          >
            Filter zurücksetzen
            <i class="far fa-sliders-v"></i>
          </span>
        </div>
        <div
          class="page-listing-filter--inputs"
          :class="{ active: mobileFilterOpen }"
        >
          <div class="vx-row" style="padding: 0 18px 10px 18px">
            <div class="vx-col w-full">
              <DataInput
                v-model="searchQuery"
                type="text"
                placeholder="Suche..."
                class="w-full mb-3"
                name="fullTextSearch"
                label="Firmensuche"
              />
            </div>
            <div class="vx-col w-full">
              <DataInput
                v-model="landwehrQuery"
                type="bool"
                class="w-full"
                name="fullTextSearch"
                label="Landwehr"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { paginationMixin } from "@/mixins/paginationMixin.js";
import gql from "graphql-tag";
import DataInput from "@/components/ui/DataInput";
import CompanyListEntry from "./CompanyListEntry";

export default {
  components: {
    DataInput,
    CompanyListEntry
  },
  mixins: [paginationMixin("companies")],
  data() {
    return {
      deleteId: null,
      mobileFilterOpen: false,
      searchQuery: null,
      landwehrQuery: false,
      currentPage: 1
    };
  },
  apollo: {
    companies: {
      query: gql`
        query companies($page: Int!, $size: Int, $filter: CompanyFilter) {
          companies(page: $page, size: $size, filter: $filter) {
            total
            results {
              id
              landwehrId
              name
              contactPartners {
                salutation
                firstName
                lastName
                telephone
                telephoneMobile
                email
              }
              postAddress {
                id
                street
                zip
                city
                telephone
                name
              }
              billingAddress {
                id
                street
                zip
                city
                telephone
                name
              }
              deliveryAddress {
                id
                street
                zip
                city
                telephone
                name
              }
            }
          }
        }
      `,
      update(data) {
        for (const cIdx in data.companies.results) {
          let company = data.companies.results[cIdx];

          if (company.postAddress) {
            company.displayAddress = company.postAddress;
          } else if (company.billingAddress) {
            company.displayAddress = company.billingAddress;
          } else if (company.deliveryAddress) {
            company.displayAddress = company.deliveryAddress;
          }

          data.companies.results[cIdx] = company;
        }

        return data.companies;
      },
      fetchPolicy: "network-only",
      variables() {
        return {
          page: this.currentPage,
          size: this.paginationPageSize,
          filter: {
            search: this.searchQuery,
            landwehr: this.landwehrQuery
          }
        };
      }
    }
  },
  methods: {
    confirmDeleteRecord(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: `Du bist dabei eine Firma zu löschen. Wirklich löschen?`,
        accept: this.deleteRecord,
        acceptText: "Löschen"
      });
    },
    deleteRecord() {
      console.log("todo: insert delete logic");
      this.showDeleteSuccess();
      // this.$apollo
      //   .mutate({
      //     mutation: gql`
      //       mutation($id: ID!) {
      //         companyDelete(id: $id) {
      //           id
      //         }
      //       }
      //     `,
      //     variables: {
      //       id: this.deleteId
      //     }
      //     // update: (store, { data: { vacancyDelete } }) => {
      //     // console.log(store);
      //     // console.log(data);
      //     // }
      //   })
      //   .then(() => {
      //     this.showDeleteSuccess();
      //   });
    },
    showDeleteSuccess() {
      this.deleteId = null;
      this.$vs.notify({
        color: "success",
        title: "Firma gelöscht",
        text: "Die ausgewählte Firma wurde gelöscht"
      });
    }
  }
};
</script>

<style scoped>
.loading-animation > * {
  display: inline-block !important;
  animation: rotate 1s linear 0s infinite;
}
.loading-animation {
  display: inline-block;
}
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
</style>
